import type * as GraphQLTypes from '../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddPackageTicketMutationVariables = GraphQLTypes.Exact<{
  packageId: GraphQLTypes.Scalars['String'];
  packageTicketInput: GraphQLTypes.CreateTicketPackageInput;
}>;


export type AddPackageTicketMutationResult = (
  { __typename?: 'Mutation' }
  & Pick<GraphQLTypes.Mutation, 'addPackageTicket'>
);


export const AddPackageTicketDocument = /*#__PURE__*/ gql`
    mutation addPackageTicket($packageId: String!, $packageTicketInput: CreateTicketPackageInput!) {
  addPackageTicket(packageId: $packageId, packageTicketInput: $packageTicketInput)
}
    `;

/**
 * __useAddPackageTicketMutation__
 *
 * To run a mutation, you first call `useAddPackageTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPackageTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPackageTicketMutation, { data, loading, error }] = useAddPackageTicketMutation({
 *   variables: {
 *      packageId: // value for 'packageId'
 *      packageTicketInput: // value for 'packageTicketInput'
 *   },
 * });
 */
export function useAddPackageTicketMutation(baseOptions?: Apollo.MutationHookOptions<AddPackageTicketMutationResult, AddPackageTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPackageTicketMutationResult, AddPackageTicketMutationVariables>(AddPackageTicketDocument, options);
      }
export type AddPackageTicketMutationHookResult = ReturnType<typeof useAddPackageTicketMutation>;